<template>
  <tr>
    <td>
      <sui-button
        v-for="action in actionList"
        v-bind:content="action"
        v-on:click="buttonAction(action)"
        v-bind:key="action"
      />
    </td>
    <td>{{ student.lastName }}</td>
    <td>{{ student.firstName }}</td>
  </tr>
</template>

<script>
export default {
  name: 'StudentTableRow',
  props: ['student', 'actions'],
  computed: {
    actionList() {
      return this.actions || [];
    },
  },
  methods: {
    buttonAction(value) {
      this.$emit('action', { action: value, student: this.student });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/students/StudentTableRow.vue